import {
  DO_FORCE_ACTIVATE_PAYMENT,
  SET_FORCE_ACTIVATION_RESULT,
} from 'state/actionTypes';

export const forceActivate = payload => ({
  type: DO_FORCE_ACTIVATE_PAYMENT,
  payload,
});

export const setForceActivationResult = result => ({
  type: SET_FORCE_ACTIVATION_RESULT,
  result,
});
